import { render } from "./ZapiProductCard.vue?vue&type=template&id=1d02caef&scoped=true"
import script from "./ZapiProductCard.vue?vue&type=script&lang=js"
export * from "./ZapiProductCard.vue?vue&type=script&lang=js"

import "./ZapiProductCard.vue?vue&type=style&index=0&id=1d02caef&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d02caef"]])

export default __exports__